module.exports = __webpack_public_path__ + "static/formal_13516081-a902bf10c31d4ce55c0cc72461692cc3.jpg";